import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "react-hot-toast";
import DynamicQuestionnaire from "../Components/DynamicQuestionnaire/client/DynamicQuestionnaire";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid"; // You may need to install this package if not already installed
import useWebsiteAnalysis from "../Components/OnboardingForm/hooks/useWebsiteAnalysis";

/**
 * TestQuestionnaire Page
 * A test environment for the DynamicQuestionnaire component
 */
const TestQuestionnaire = () => {
  const navigate = useNavigate();
  const {
    analyzeWebsite,
    analysisResults,
    isLoading: isAnalyzing,
    analyzeError,
  } = useWebsiteAnalysis();

  // Track the analyzed website URL
  const [analyzedWebsiteUrl, setAnalyzedWebsiteUrl] = useState("");

  // Generate test user and project IDs
  const testUserId = "test-user-" + uuidv4().substring(0, 8);
  const testProjectId = "test-project-" + uuidv4().substring(0, 8);

  // Handle website URL analysis using the real hook
  const handleAnalyzeUrl = async (url) => {
    try {
      setAnalyzedWebsiteUrl(url); // Store the analyzed URL
      await analyzeWebsite(url);
      // No need to set analysisResults, isAnalyzing, or analyzeError manually
    } catch (error) {
      // Error is handled in the hook
    }
  };

  // Handle questionnaire submission
  const handleSubmit = async (data) => {
    try {
      toast.success("Questionnaire submitted successfully!");
      console.log("Submitted data:", data);

      // Redirect to a placeholder success page
      setTimeout(() => {
        navigate("/");
      }, 2000);

      return true;
    } catch (error) {
      console.error("Error submitting questionnaire:", error);
      toast.error("Failed to submit questionnaire. Please try again.");
      return false;
    }
  };

  // Handle questionnaire completion
  const handleComplete = (formattedData) => {
    console.log("Formatted data for brand profile:", formattedData);
    toast.success("Questionnaire completed! Data ready for brand profile.");
  };

  return (
    <div className="bg-[#111111] min-h-screen">
      <div className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-white mb-4">
              Dynamic Questionnaire Test
            </h1>
            <p className="text-gray-300 mb-8">
              This is a test environment for the dynamic questionnaire
              component. Fill out the form to test the functionality.
            </p>
            <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4 mb-4">
              <p className="text-blue-400">
                <strong>Test User ID:</strong> {testUserId}
              </p>
              <p className="text-blue-400">
                <strong>Test Project ID:</strong> {testProjectId}
              </p>
            </div>
          </div>

          <DynamicQuestionnaire
            userId={testUserId}
            projectId={testProjectId}
            onSubmit={handleSubmit}
            onAnalyzeUrl={handleAnalyzeUrl}
            onComplete={handleComplete}
            websiteUrl={analyzedWebsiteUrl}
            analysisResults={analysisResults}
            isAnalyzing={isAnalyzing}
            analyzeError={analyzeError}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default TestQuestionnaire;
